import { Header, Hero, Services, About, Footer } from './components';
import './App.css';

/**
 * Home page - Landing page for 3oh.io
 * Showcases Web3 and AI products/services
 */
function Home() {
	return (
		<div className="app">
			<Header />
			<main>
				<Hero />
				<Services />
				<About />
			</main>
			<Footer />
		</div>
	);
}

export default Home;
